import { render, staticRenderFns } from "./DeviceReducePlay.vue?vue&type=template&id=71fb195a&scoped=true"
import script from "./DeviceReducePlay.vue?vue&type=script&lang=js"
export * from "./DeviceReducePlay.vue?vue&type=script&lang=js"
import style0 from "./DeviceReducePlay.vue?vue&type=style&index=0&id=71fb195a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb195a",
  null
  
)

export default component.exports